import { render, staticRenderFns } from "./member-grade-setting.vue?vue&type=template&id=1f8c719a&scoped=true&"
import script from "./member-grade-setting.vue?vue&type=script&lang=js&"
export * from "./member-grade-setting.vue?vue&type=script&lang=js&"
import style0 from "./member-grade-setting.vue?vue&type=style&index=0&id=1f8c719a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f8c719a",
  null
  
)

export default component.exports